import { menuFirsts } from "../../constants/menu";
import DetailRole from "../../page/role/detail/detail";
import ListRoles from "../../page/role/list/list";
import { routeName } from "../routers-name";

const routeRole = [
    {
      ...menuFirsts.ROLE,
      key: menuFirsts.ROLE.key,
      name: menuFirsts.ROLE.name,
      code: menuFirsts.ROLE.code,
      textName: menuFirsts.ROLE.textName,
      active: false,
      appBar: true,
      component: ListRoles
    } ,
    {
      ...menuFirsts.ROLE,
      key: menuFirsts.ROLE.key,
      name: menuFirsts.ROLE.name,
      code: menuFirsts.ROLE.name + '.Add',
      textName: menuFirsts.ROLE.textName,
      path: routeName.role + '/add',
      active: false,
      appBar: true,
      component: DetailRole
    } ,
    {
      ...menuFirsts.ROLE,
      key: menuFirsts.ROLE.key,
      name: menuFirsts.ROLE.name,
      code: menuFirsts.ROLE.name + '.Edit',
      textName: menuFirsts.ROLE.textName,
      path: routeName.role + '/detail/:id',
      active: false,
      appBar: true,
      component: DetailRole
    } ,
]

export default routeRole